export async function updateAppPricing(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { appAddress, installPrice, accessDuration, signer } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for updateAppPricing operation.');
    }
    const simpleApp = appRegistryDapp.callApp(appAddress);
    const callData = simpleApp.interface.encodeFunctionData('updatePricing', [
        installPrice,
        accessDuration,
    ]);
    return smartAccount.sendUserOp({
        toAddress: [appAddress],
        callData: [callData],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
